module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7a6u4"))).then(() => parcelRequire('37nVf'));